import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export const NotFoundPage = () => {
    const navigate = useNavigate();
  return (
   <Container
      maxWidth="sm"
      sx={{
        textAlign: "center",
        mt: 10,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Typography variant="h2" fontWeight="bold">
          404
        </Typography>
        <Typography variant="h5" color="text.secondary">
          Oops! The page you’re looking for doesn’t exist.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 3, borderRadius: 2 }}
        onClick={() => navigate("/")}
        >
          Go Home
        </Button>
      </Box>
    </Container>
  );
};
